// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
import type { TSendIncrementRequest, TSendIncrementModel, IMappers, TSendIncrementResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIncrementResponse } from '../../entities/increment/IncrementResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createSendIncrementModel(parameters: TSendIncrementRequest): TSendIncrementModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'browser-telemetry',
    pathApi: '/v1/send-increment/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ISendIncrementOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TSendIncrementRequest;
}

export async function fetchSendIncrement<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ISendIncrementOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TSendIncrementResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createSendIncrementModel(parameters),
    config,
  )) as FetchResponse<TSendIncrementResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIncrementResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TSendIncrementResponse>;
}
